import React, { useEffect, useState } from 'react';
import { View, Image, TextInput, ScrollView, FlatList, ActivityIndicator } from 'react-native';
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import RadioButton from '../../Componentsv1/RadioButton';
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { event_searchAthletes, event_searchTeams } from '../../store/actionsv1/events';
import { market_createPlayerFilter, market_deletePlayerFilter, market_getPlayerFilterById, market_updatePlayerFilter } from '../../store/actionsv1/markets';
import { player_getBulkPlayers, player_getHelpPromptById, player_smartSearch } from '../../store/actionsv1/player';
import { PublicPlayerProps, SmartSearchRequestProps } from '../../store/types/auth_svc';
import { MarketProps, PlayerFilterProps } from '../../store/types/mk_svc';
import { AthleteProps, LeagueProps, TeamProps } from '../../store/types/sr_svc';
import PlayerCard from '../Social/components/PlayerCard';
import LeagueLozenge from './components/LeagueLozenge';
import MarketLozenge from './components/MarketLozenge';
import TeamLozenge from './components/TeamLozenge';
import { order_getEmptyFilter } from './helpers/orders';
import AthleteLozenge from './components/AthleteLozenge';

const books = [
    'DraftKings', 'FanDuel', 'MGM', 'PointsBet'
]

type GradeBoxType = {
    min:number,
    max:number,
    success_color:string,
    fail_color:string,
    locked_color:string
}

const grade_boxes:GradeBoxType[] = [
    { min: 0, max: 79, success_color: 'rgba(125,205,133,0.2)', fail_color: 'rgba(213,87, 59, 0.2)', locked_color: Colors.shades.shade100 },
    { min: 80, max: 94, success_color: 'rgba(125,205,133,0.4)', fail_color: 'rgba(213,87, 59, 0.4)', locked_color: Colors.shades.shade100 },
    { min:95, max: 97.5, success_color: 'rgba(125,205,133,0.6)', fail_color: 'rgba(213,87, 59, 0.6)', locked_color: Colors.shades.shade100 },
    { min:97.6, max: 99.99, success_color: 'rgba(125,205,133,0.8)', fail_color: 'rgba(213,87, 59, 0)', locked_color: Colors.shades.shade100 },
    { min: 100, max: 200, success_color: 'rgba(125,205,133,1)', fail_color: 'rgba(213,87, 59, 0)', locked_color: Colors.shades.shade100 }
]

export const ManageFilterScreen = ({ route, navigation }:any) => {
    const [ draft_filter, setDraftFilter ] = useState<PlayerFilterProps>(order_getEmptyFilter())
    const [ save_loading, setSaveLoading ] = useState(false);
    const [ show_premium_options, setShowPremiumOptions ] = useState(false);
    const [ athlete_search_value, setAthleteSearchValue ] = useState('');
    const [ athlete_search_loading, setAthleteSearchLoading ] = useState(false);
    const [ player_search_value, setPlayerSearchValue ] = useState('');
    const [ player_search_loading, setPlayerSearchLoading ] = useState(false);
    const [ team_search_value, setTeamSearchValue ] = useState('');
    const [ team_search_loading, setTeamSearchLoading ] = useState(false);
    const [ team_pool, setTeamPool ] = useState<TeamProps[]>([])
    const [ athlete_pool, setAthletePool ] = useState<AthleteProps[]>([])
    const [ player_pool, setPlayerPool ] = useState<PublicPlayerProps[]>([])

    const dispatch = useDispatch();

    const app_size:{width:number, height:number} = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width)
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const filtered_players = useSelector((state:any) => state.social.stored_players.filter((p:PublicPlayerProps) => `${p.first_name.toLowerCase()} ${p.last_name.toLowerCase()} ${p.username.toLowerCase()}`.includes(player_search_value.toLowerCase())))
    
    const player_filters:PlayerFilterProps[] = useSelector((state:any) => state.market.player_filters, (left, right) => left.length == right.length)
    const player_filter = player_filters.find(pf => pf.player_filter_id == route.params?.player_filter_id)
    let saveable = true
    if(false && !route.params?.player_filter_id && player?.type != 'premium'){
        saveable = false
    }

    useEffect(() => {
        if(!route.params?.player_filter_id){ return }//Do nothing, this is a new one
        getFilterFromServer(route.params.player_filter_id)
    },[route.params?.player_filter_id])

    useEffect(() => {
        if(!player_filter){ return }
        if(!player_filter.filter.league_ids){ player_filter.filter.league_ids = [] }
        setDraftFilter(player_filter)
        if(player_filter.filter.player_ids.length > 0){
            dispatch(player_getBulkPlayers(player_filter.filter.player_ids))
        }
    },[player_filter])

    const getFilterFromServer = async(player_filter_id:string) => {
        if(player_filter){ return }
        setSaveLoading(true)
        await dispatch(market_getPlayerFilterById(player_filter_id))
        setSaveLoading(false)
    }


    //Save Filter
    const handleSaveFilter = async() => {
        const errors = isValid()
        if(errors.length > 0){ return alert(errors[0]) }
        if(save_loading){ return } // Stop button mashing
        if(draft_filter.name === ''){ return alert('Please give your quick filter a name!') }
        if(draft_filter.filter.market_ids.length == 0){ return alert('Filter must include at least 1 market type') }
        let premium = false
        if(draft_filter.filter.external_book && draft_filter.filter.external_book != ''){ premium = true }
        if(draft_filter.filter.minimum_grade > 0){ premium = true }
        setSaveLoading(true)
        if(draft_filter.player_filter_id){
            await dispatch(market_updatePlayerFilter({ ...draft_filter, premium }))
        } else {
            await dispatch(market_createPlayerFilter({ ...draft_filter, premium }))
        }
        setSaveLoading(false)
        navigation.goBack()
    }

    const handleDeleteFilter = async() => {
        if(!route.params.player_filter_id){ return }
        if(save_loading){ return }
        const confirmed = await confirm('Are you sure you want to delete this filter?');
        if(!confirmed){ return }
        setSaveLoading(true);
        await dispatch(market_deletePlayerFilter(route.params.player_filter_id))
        setSaveLoading(false);
        navigation.goBack();
    }


    //Player filters
    const handlePlayerSearch = async() => {
        setPlayerSearchLoading(true)
        let search_request:SmartSearchRequestProps = {
            player_id: player?.player_id??'0',
            search_value: player_search_value,
            offset: 0
        }
        await dispatch(player_smartSearch(search_request))
        setPlayerSearchLoading(false)
    }
    const handlePlayerSelect = (player:PublicPlayerProps) => {
        let existing_players = draft_filter.filter.player_ids
        let already_selected = existing_players.find(l => l == player.player_id)
        if(already_selected){
            existing_players = existing_players.filter(l => l != player.player_id)
            setPlayerPool(player_pool.filter(t => t.player_id != player.player_id))
        } else {
            existing_players = existing_players.concat(player.player_id)
            setPlayerPool([player].concat(player_pool))

        }
        setDraftFilter({ ...draft_filter, filter: { ...draft_filter.filter, player_ids: existing_players } })
    }


    //League Select Handlers
    const leagues:LeagueProps[] = useSelector((state:any) => state.event.leagues, (left, right) => left.length == right.length)
    const handleLeagueSelect = (league:LeagueProps) => {
        let existing_leagues = draft_filter.filter.league_ids
        let already_selected = existing_leagues.find(l => l == league.league_id)
        if(already_selected){
            existing_leagues = existing_leagues.filter(l => l != league.league_id)
        } else {
            if(existing_leagues.length > 0){ return alert('Only 1 league can be selected') }
            existing_leagues = existing_leagues.concat(league.league_id)
        }
        setDraftFilter({ ...draft_filter, filter: { ...draft_filter.filter, league_ids: existing_leagues } })
    }

    //Market Select Handlers
    const markets:MarketProps[] = useSelector((state:any) => state.market.markets, (left, right) => left.length == right.length)

    let filtered_markets = markets.filter(m => draft_filter.filter.market_types == 'event' ? m.type != 'Stat' : m.type == 'Stat');
    if(draft_filter.filter.league_ids.length > 0){
        let leagues_added = leagues.filter(l => draft_filter.filter.league_ids.map(id => id.toString()).includes(l.league_id.toString()))
        let default_markets:string[] = []
        leagues_added.map(l => { 
            if(!l.default_markets){ return }
            l.default_markets.map(dm => default_markets.push(dm.market_id.toString()))
        })
        filtered_markets = filtered_markets.filter(m => default_markets.includes(m.market_id.toString()))
    }
    //Fitler markets to only those that are available in selected leagues
    const handleMarketSelect = (market:MarketProps) => {
        let existing_markets = draft_filter.filter.market_ids
        let already_selected = existing_markets.find(l => l == market.market_id)
        if(already_selected){
            existing_markets = existing_markets.filter(l => l != market.market_id)
        } else {
            existing_markets = existing_markets.concat(market.market_id)
        }
        setDraftFilter({ ...draft_filter, filter: { ...draft_filter.filter, market_ids: existing_markets } })
    }

    //Filter teams
    const teams_list:{ updated:number, teams:TeamProps[]} = useSelector((state:any) => state.event.teams_list, (left, right) => left.updated == right.updated);
    const { teams } = teams_list;
    
    const handleTeamSearch = async() => {
        setTeamSearchLoading(true)
        await dispatch(event_searchTeams(team_search_value, draft_filter.filter.league_ids, 0))
        setTeamSearchLoading(false)
    }
    const handleTeamSelect = (team:TeamProps) => {
        let existing_teams = draft_filter.filter.team_ids
        let already_selected = existing_teams.find(l => l == team.team_id)
        if(already_selected){
            existing_teams = existing_teams.filter(l => l != team.team_id)
            setTeamPool(team_pool.filter(t => t.team_id != team.team_id))
        } else {
            existing_teams = existing_teams.concat(team.team_id)
            setTeamPool([team].concat(team_pool))
        }
        setDraftFilter({ ...draft_filter, filter: { ...draft_filter.filter, team_ids: existing_teams } })
    }

    //Filter athletes
    const athletes_list:{ updated:number, athletes:AthleteProps[]} = useSelector((state:any) => state.event.athletes_list, (left, right) => left.updated == right.updated);
    const { athletes } = athletes_list;
    
    const handleAthleteSearch = async() => {
        setAthleteSearchLoading(true)
        await dispatch(event_searchAthletes(athlete_search_value, draft_filter.filter.league_ids, 0))
        setAthleteSearchLoading(false)
    }
    const handleAthleteSelect = (athlete:AthleteProps) => {
        let existing_athletes = draft_filter.filter.athlete_ids
        let already_selected = existing_athletes.find(l => l == athlete.athlete_id)
        if(already_selected){
            existing_athletes = existing_athletes.filter(l => l != athlete.athlete_id)
            setTeamPool(team_pool.filter(t => t.team_id != athlete.athlete_id))
        } else {
            existing_athletes = existing_athletes.concat(athlete.athlete_id)
            setAthletePool([athlete].concat(athlete_pool))
        }
        setDraftFilter({ ...draft_filter, filter: { ...draft_filter.filter, athlete_ids: existing_athletes } })
    }

    const isValid = () => {
        let errors:string[] = []
        if(!draft_filter?.filter){ return ['Filter is empty'] }
        if(!draft_filter.name || player_filter?.name == ''){ errors.push('Must add name to filter') }
        if(draft_filter.filter.league_ids.length < 1){ errors.push('Need to select 1 league') }
        if(!draft_filter.filter.market_types){ errors.push('Must select market type') }
        if(draft_filter.filter.league_ids.length > 1){ errors.push('Filter can only include up to 1 leagues') }
        if(draft_filter.filter.market_ids.length == 0){ errors.push('Need to selected at least one market') }
        if(draft_filter.filter.minimum_grade > 0 && player?.type != 'premium'){ errors.push('Only premium users are allowed to create filters with minimum grades') }
        if(draft_filter.filter.external_book && draft_filter.filter.external_book != '' && player?.type != 'premium'){ errors.push('Only premium users are allowed to compare to an external book') }
        return errors
    }

    const minimumGradeText = (minimum_grade:number) => {
        let text = 'Show me everything'
        if(minimum_grade >= 80){
            text = 'I just want to get this fulfilled as long as its reasonable'
        }
        if(minimum_grade >= 95){
            text = 'Around the consensus price but may not be better'
        }
        if(minimum_grade >= 97.5){
            text = 'Better than the Consensus price with vig'
        }
        if(minimum_grade >= 100){
            text = 'MAX - Better than the Consensus price with vig removed'
        }
        return text
    }

    const errors = isValid()
    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView style={{ flex:1 }}>
                <View style={{ padding:20, backgroundColor:Colors.shades.shade100 }}>
                    <Text size={18} color={Colors.brand.midnight} weight='bold' textAlign='left'>{route.params?.player_filter_id?'UPDATE':'CREATE NEW'} FILTER</Text>
                    <Text style={{ marginTop:5 }} size={14} color={Colors.brand.midnight} weight='regular'>Create rulesets to filter all open orders on BettorEdge.</Text>
                </View>
                <View nativeID='filter_name' style={{ padding:20 }}>
                    <Text size={18} color={Colors.brand.midnight} weight='semibold'>Name</Text>
                    <Text size={14} color={Colors.brand.midnight} weight='regular'>Give this filter a memorable name based on the criteria set (i.e., NFL QB Passing TDs)</Text>
                    <View style={{ backgroundColor:Colors.shades.shade100, borderRadius:4, marginTop: 10}}>
                        <TextInput style={{ color:Colors.brand.midnight, padding:10 }} value={draft_filter.name} placeholder='Filter Name' onChangeText={(e) => setDraftFilter({ ...draft_filter, name: e })}/>
                    </View>
                </View>
                <View nativeID='filter_people' style={{ padding:20 }}>
                    <Text size={18} color={Colors.brand.midnight} weight='semibold'>Show Orders From</Text>
                    <Text style={{ marginTop:5 }} size={14} color={Colors.brand.midnight} weight='regular'>Set specific players or groups you would like to see these orders from (i.e., people I follow or Todd my neighbor)</Text>
                    <View style={{ backgroundColor:Colors.shades.shade100, borderRadius:4, marginTop: 8, padding:14}}>
                        <TouchableOpacity style={{ flexDirection:'row', alignItems:'center' }}>
                            <RadioButton selected={!draft_filter.filter.following_only&&!draft_filter.filter.custom_players?true:false} onSelect={() => setDraftFilter({ ...draft_filter, filter: { ...draft_filter.filter, following_only: false, custom_players:false, player_ids: [] } })}/>
                            <Text style={{ marginLeft: 14 }} size={14} color={Colors.brand.midnight} weight='semibold'>Everyone</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', marginTop:12 }}>
                            <RadioButton selected={draft_filter.filter.following_only?true:false} onSelect={() => { 
                                setDraftFilter({ ...draft_filter, filter: { ...draft_filter.filter, following_only: true, custom_players:false, player_ids: [] } })
                                setPlayerPool([])
                                }}/>
                            <Text style={{ marginLeft: 14 }} size={14} color={Colors.brand.midnight} weight='semibold'>People I Follow</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', marginTop:12 }}>
                            <RadioButton selected={draft_filter.filter.custom_players?true:false} onSelect={() => {
                                setDraftFilter({ ...draft_filter, filter: { ...draft_filter.filter, following_only: false, custom_players:true } })
                                setPlayerPool([])
                                }}/>
                            <Text style={{ marginLeft: 14 }} size={14} color={Colors.brand.midnight} weight='semibold'>Custom Players</Text>
                            {draft_filter.filter.player_ids.length > 0 ?
                            <View style={{marginLeft:8, borderRadius:100, height:24, width:24, backgroundColor:Colors.highlights.highlight200, justifyContent:'center', alignItems:'center'}}>
                                <Text size={12} color={Colors.shades.white} weight='bold' textAlign='center'>{draft_filter.filter.player_ids.length}</Text>
                            </View>
                            :<></>}
                        </TouchableOpacity>
                        {draft_filter.filter.custom_players ?
                        <View>
                            <View style={{ flexDirection:'row', alignItems:'center', padding:10, paddingRight:5, paddingLeft:5 }}>
                                <View style={{ flexDirection:'row', flex:1, backgroundColor:Colors.shades.white, borderRadius:22 }}>
                                    <Icon containerStyle={{ alignSelf:'center', padding:10 }} name='search' type='feather' color={Colors.brand.electric} size={18} />
                                    <TextInput style={{ flex:1, fontFamily:'barlow-regular', fontSize:14, color:Colors.brand.midnight, padding:5}} 
                                    value={player_search_value} 
                                    placeholder='Search Other Players...'
                                    onChangeText={(text) => setPlayerSearchValue(text)}/>
                                </View>
                                <TouchableOpacity style={{ padding:5, marginLeft:10 }} onPress={() => handlePlayerSearch()}>
                                    <Text size={14} color={Colors.brand.electric} weight='semibold'>Search</Text>
                                </TouchableOpacity>
                            </View>
                            <View style={{ flexDirection:'row', overflow:'scroll'}}>
                            {player_pool.map((t, i) => {
                                const selected = draft_filter.filter.player_ids.find(el => el == t.player_id) ? true : false
                                if(!selected){ return<></> }
                                return (
                                    <View style={{margin:3}}>
                                        <PlayerCard 
                                            backgroundColor={Colors.highlights.highlight500Faded} 
                                            width={(app_size.width / 3 ) - 30}
                                            hide_bio hide_follow_status 
                                            vertical 
                                            viewer_id={player?.player_id??'0'} 
                                            player={t} 
                                            onPlayerPress={(player) => handlePlayerSelect(player)}/>
                                    </View>
                                )
                            })}
                            </View>
                            <View style={{ flexDirection:'row', flexWrap:'wrap', justifyContent:'center', marginTop:10 }}>
                                {filtered_players.map((p, i) => {
                                    return (
                                        <View style={{ margin:3 }}>
                                            <PlayerCard width={(app_size.width / 3) - 30} hide_bio hide_follow_status vertical viewer_id={player?.player_id??'0'} player={p} onPlayerPress={(player) => handlePlayerSelect(player)}/>
                                        </View>
                                    )
                                })}
                            </View>
                        </View>
                        :<></>}
                    </View>
                </View>
                <View nativeID='filter_order_status' style={{ padding:20 }}>
                    <Text size={18} color={Colors.brand.midnight} weight='semibold'>Event Status</Text>
                    <Text style={{ marginTop:5 }} size={14} color={Colors.brand.midnight} weight='regular'>Set to show all orders or filter to only orders related to an event that is currently inprogress</Text>
                    <View style={{ backgroundColor:Colors.shades.shade100, borderRadius:4, marginTop: 8, padding:14}}>
                        <TouchableOpacity style={{ flexDirection:'row', alignItems:'center' }}>
                            <RadioButton selected={draft_filter.filter.live_only?false:true} onSelect={() => setDraftFilter({ ...draft_filter, filter: { ...draft_filter.filter, live_only: false } })}/>
                            <Text style={{ marginLeft: 14 }} size={14} color={Colors.brand.midnight} weight='semibold'>Any Event Status (Scheduled and Live)</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', marginTop:12 }}>
                            <RadioButton selected={draft_filter.filter.live_only?true:false} onSelect={() => setDraftFilter({ ...draft_filter, filter: { ...draft_filter.filter, live_only: true } })}/>
                            <Text style={{ marginLeft: 14 }} size={14} color={Colors.brand.midnight} weight='semibold'>Live Only - Events currently in progress</Text>
                        </TouchableOpacity>
                    </View>
                </View>
                <View nativeID='filter_leagues' style={{ padding:20 }}>
                    <Text size={18} color={Colors.brand.midnight} weight='semibold'>Leagues</Text>
                    <Text style={{ marginTop:5 }} size={14} color={Colors.brand.midnight} weight='regular'>Only show orders related to specific leagues (must select 1)</Text>
                    <View style={{ flexDirection:'row', flexWrap:'wrap', backgroundColor:Colors.shades.shade100, borderRadius:4, marginTop: 8, padding:14}}>
                        {leagues.filter(l => l.status === 'active').map((l, i) => {
                            const selected = draft_filter.filter.league_ids && draft_filter.filter.league_ids.find(el => el == l.league_id) ? true : false
                            return (
                                <LeagueLozenge is_active={selected} league={l} onSelect={(league) => handleLeagueSelect(league)}/>
                            )
                        })}
                    </View>
                </View>
                {draft_filter.filter.league_ids?.length > 0 ?
                <View nativeID='filter_order_status' style={{ padding:20 }}>
                    <Text size={18} color={Colors.brand.midnight} weight='semibold'>Market Types</Text>
                    <Text style={{ marginTop:5 }} size={14} color={Colors.brand.midnight} weight='regular'>Set to show all orders or filter to only orders related to an event that is currently inprogress</Text>
                    <View style={{ backgroundColor:Colors.shades.shade100, borderRadius:4, marginTop: 8, padding:14}}>
                        <TouchableOpacity style={{ flexDirection:'row', alignItems:'center' }}>
                            <RadioButton selected={draft_filter.filter.market_types=='event'?true:false} onSelect={() => setDraftFilter({
                                ...draft_filter,
                                filter: {
                                    ...draft_filter.filter,
                                    market_types: 'event'
                                }
                            })}/>
                            <Text style={{ marginLeft: 14 }} size={14} color={Colors.brand.midnight} weight='semibold'>Event Level (Winner, Spread, Total)</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', marginTop:12 }}>
                            <RadioButton selected={draft_filter.filter.market_types=='player_stat'?true:false} onSelect={() => setDraftFilter({
                                ...draft_filter,
                                filter: {
                                    ...draft_filter.filter,
                                    market_types: 'player_stat'
                                }
                            })}/>
                            <Text style={{ marginLeft: 14 }} size={14} color={Colors.brand.midnight} weight='semibold'>Player Stats</Text>
                        </TouchableOpacity>
                    </View>
                </View>
                :<></>}
                {draft_filter.filter.league_ids?.length > 0 && draft_filter.filter.market_types ?
                <View nativeID='filter_markets' style={{ padding:20 }}>
                    <Text size={18} color={Colors.brand.midnight} weight='semibold'>Included Markets</Text>
                    <Text style={{ marginTop:5 }} size={14} color={Colors.brand.midnight} weight='regular'>Only show orders related to specific markets</Text>
                    <View style={{ flexDirection:'row', flexWrap:'wrap', backgroundColor:Colors.shades.shade100, borderRadius:4, marginTop: 8, padding:14}}>
                        {filtered_markets.map((m, i) => {
                            const selected = draft_filter.filter.market_ids.find(el => el == m.market_id) ? true : false
                            return (
                                <MarketLozenge is_active={selected} market={m} onSelect={(market) => handleMarketSelect(market)}/>
                            )
                        })}
                    </View>
                </View>
                :<></>}
                {draft_filter.filter.league_ids?.length > 0 && draft_filter.filter.market_types == 'event' ?
                <View nativeID='filter_teams' style={{ padding:16 }}>
                    <Text size={16} color={Colors.brand.midnight} weight='semibold'>Included Teams</Text>
                    <View style={{ backgroundColor:Colors.shades.shade100, borderRadius:4, marginTop: 8, padding:14}}>
                        <View style={{ flexDirection:'row', alignItems:'center', padding:10, paddingRight:5, paddingLeft:5 }}>
                            <View style={{ flexDirection:'row', flex:1, backgroundColor:Colors.shades.white, borderRadius:22 }}>
                                <Icon containerStyle={{ alignSelf:'center', padding:10 }} name='search' type='feather' color={Colors.brand.electric} size={18} />
                                <TextInput style={{ flex:1, fontFamily:'barlow-regular', fontSize:14, color:Colors.brand.midnight, padding:5}} 
                                value={team_search_value} 
                                placeholder='Search Teams...'
                                onChangeText={(text) => setTeamSearchValue(text)}/>
                            </View>
                            <TouchableOpacity style={{ padding:5, marginLeft:10 }} onPress={() => handleTeamSearch()}>
                                <Text size={14} color={Colors.brand.electric} weight='semibold'>Search</Text>
                            </TouchableOpacity>
                        </View>
                        <View style={{ flexDirection:'row', flexWrap:'wrap'}}>
                        {team_pool.map((t, i) => {
                            const selected = draft_filter.filter.team_ids.find(el => el == t.team_id) ? true : false
                            if(!selected){ return<></> }
                            return (
                                <TeamLozenge is_active={selected} team={t} abbr_only onSelect={(team) => handleTeamSelect(team)}/>
                            )
                        })}
                        </View>
                        <View style={{ flexDirection:'row', flexWrap:'wrap'}}>
                        {teams.map((t, i) => {
                            return (
                                <TeamLozenge is_active={false} team={t} onSelect={(team) => handleTeamSelect(team)}/>
                            )
                        })}
                    </View>
                    </View>
                </View>
                :<></>}
                {draft_filter.filter.league_ids?.length > 0 && draft_filter.filter.market_types == 'player_stat' ?
                <View nativeID='filter_athletes' style={{ padding:16 }}>
                    <Text size={16} color={Colors.brand.midnight} weight='semibold'>Included Athletes</Text>
                    <View style={{ backgroundColor:Colors.shades.shade100, borderRadius:4, marginTop: 8, padding:14}}>
                        <View style={{ flexDirection:'row', alignItems:'center', padding:10, paddingRight:5, paddingLeft:5 }}>
                            <View style={{ flexDirection:'row', flex:1, backgroundColor:Colors.shades.white, borderRadius:22 }}>
                                <Icon containerStyle={{ alignSelf:'center', padding:10 }} name='search' type='feather' color={Colors.brand.electric} size={18} />
                                <TextInput style={{ flex:1, fontFamily:'barlow-regular', fontSize:14, color:Colors.brand.midnight, padding:5}} 
                                value={athlete_search_value} 
                                placeholder='Search Athletes...'
                                onChangeText={(text) => setAthleteSearchValue(text)}/>
                            </View>
                            <TouchableOpacity style={{ padding:5, marginLeft:10 }} onPress={() => handleAthleteSearch()}>
                                <Text size={14} color={Colors.brand.electric} weight='semibold'>Search</Text>
                            </TouchableOpacity>
                        </View>
                        <View style={{ flexDirection:'row', flexWrap:'wrap'}}>
                        {athlete_pool.map((a, i) => {
                            const selected = draft_filter.filter.athlete_ids.find(el => el == a.athlete_id) ? true : false
                            if(!selected){ return<></> }
                            return (
                                <AthleteLozenge is_active={selected} athlete={a} abbr_only onSelect={(athlete) => handleAthleteSelect(athlete)}/>
                            )
                        })}
                        </View>
                        <View style={{ flexDirection:'row', flexWrap:'wrap'}}>
                        {athletes.map((a, i) => {
                            return (
                                <AthleteLozenge is_active={false} athlete={a} onSelect={(athlete) => handleAthleteSelect(athlete)}/>
                            )
                        })}
                    </View>
                    </View>
                </View>
                :<></>}
            </ScrollView>
            <View nativeID='footer_actions'>
                <View nativeID='premium_actions'>
                    {show_premium_options ?
                    <View style={{ flex:1, position:'absolute', maxHeight:app_size.height*0.75, bottom:0, left:0, right:0, borderTopRightRadius:8, borderTopLeftRadius:8, backgroundColor:Colors.incentive.gold}}>
                        <ScrollView style={{ flex:1 }}>
                            {draft_filter ?
                            <View nativeID='order_grades' style={{ padding:20 }}>
                                <Text size={16} color={Colors.shades.white} weight='semibold'>Minimum Order Grade</Text>
                                <Text style={{ marginTop:5 }} size={14} color={Colors.shades.white} weight='regular'>Only show orders that are graded above a certain threshold</Text>
                                <View style={{ backgroundColor:Colors.shades.shade100, marginTop:8, borderRadius:4, padding:14 }}>
                                    <View style={{ flexDirection:'row', justifyContent:'center' }}>
                                        {grade_boxes.map(b => {
                                            const filled = draft_filter?.filter.minimum_grade >= b.min ? true : false
                                            const success = b.min > 97.5 ? true : false
                                            return (
                                                <TouchableOpacity 
                                                    style={{ height:20, width:20, margin:10, borderRadius:4, borderWidth:1, borderColor:success?b.success_color:b.fail_color, backgroundColor:filled?success?b.success_color:b.fail_color:undefined }} 
                                                    onPress={() => setDraftFilter({
                                                        ...draft_filter,
                                                        filter:{
                                                            ...draft_filter.filter,
                                                            minimum_grade: b.min
                                                        }
                                                    })}
                                                />
                                            )
                                        })}
                                    </View>
                                    <Text style={{ margin:10 }} size={14} color={Colors.brand.midnight} weight='semibold' textAlign='center'>{minimumGradeText(draft_filter.filter.minimum_grade)}</Text>
                                </View>
                            </View>
                            :<></>}
                            <View nativeID='filter_order_status' style={{ flex:1, padding:20 }}>
                                <Text size={18} color={Colors.shades.white} weight='semibold'>External Price Compare</Text>
                                <Text style={{ flex:1, marginTop:5 }} size={14} color={Colors.shades.white} weight='regular'>When viewing orders, we can show you what the price is at a specific book. Select which book below.  If the price is not available, we will use the consensus if possible.</Text>
                                <View style={{ backgroundColor:Colors.shades.shade100, borderRadius:4, marginTop: 8, padding:14}}>
                                    {books.map((b,i) => {
                                        const selected = draft_filter?.filter?.external_book == b ? true : false
                                        return (
                                        <TouchableOpacity key={b} style={{ flexDirection:'row', alignItems:'center', padding:10 }} onPress={() => {
                                            setDraftFilter({
                                                ...draft_filter,
                                                filter: { ...draft_filter.filter, external_book: b }
                                            })
                                        }}>
                                            <RadioButton selected={selected} onSelect={() => setDraftFilter({
                                                ...draft_filter,
                                                filter: { ...draft_filter.filter, external_book: b }
                                            })}/>
                                            <Text style={{ marginLeft: 14 }} size={14} color={Colors.brand.midnight} weight='semibold'>{b.toUpperCase()}</Text>
                                        </TouchableOpacity>
                                        )
                                    })}
                                </View>
                            </View>
                        </ScrollView>
                    </View>
                    :<></>}
                </View>
                <View style={{ backgroundColor:Colors.incentive.gold, borderTopRightRadius:show_premium_options?0:8, borderTopLeftRadius:show_premium_options?0:8 }}>
                    <TouchableOpacity style={{ flexDirection:'row', padding:15 }} onPress={() => setShowPremiumOptions(!show_premium_options)}>
                        <Text style={{ flex:1 }} size={16} color={Colors.shades.white} weight='bold'>{show_premium_options?'Hide':'Show'} Premium Filter Options</Text>
                        <Icon name={show_premium_options?'chevron-down':'chevron-up'} type='feather' size={16} color={Colors.shades.white} />
                    </TouchableOpacity>
                </View>
                <View style={{ backgroundColor:Colors.shades.white, padding:15, flexDirection:'row' }}>
                    <TouchableOpacity style={{ flex:1, borderWidth:1, borderColor:Colors.brand.electric, marginRight:4, padding:12 }}
                    onPress={() => navigation.goBack()}>
                        <Text size={14} color={Colors.brand.electric} weight='semibold' textAlign='center'>Cancel</Text>
                    </TouchableOpacity>
                    <TouchableOpacity

                        style={{ flex:1, backgroundColor:Colors.utility.success, marginLeft:4, padding: 12, opacity:errors.length > 0 ? 0.5 : 1 }} onPress={() => handleSaveFilter()}>
                        {save_loading ?
                        <ActivityIndicator style={{ alignSelf: 'center' }} size='small' color={Colors.shades.white} />
                        : saveable ?
                        <Text size={14} color={Colors.shades.white} weight='semibold' textAlign='center'>{route.params?.player_filter_id?'Update':'Save'}</Text>
                        :
                        <Icon containerStyle={{ alignSelf:'center' }} name='lock' type='feather' size={20} color={Colors.incentive.gold} />
                        }
                    </TouchableOpacity>
                </View> 
                {route.params?.player_filter_id ?
                <View style={{ }}>
                    <TouchableOpacity style={{ padding:15 }}
                    onPress={() => 
                        handleDeleteFilter()
                    }>
                        <Text size={14} color={Colors.utility.error} weight='semibold' textAlign='center'>Delete</Text>
                    </TouchableOpacity>
                </View>
                :<></>}
            </View>
        </View>
    )
}


export default ManageFilterScreen